import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ButtonSizes from './ButtonSizes';

const BaseButton = (props) => {
  const {
    buttonRef,
    buttonType,
    children,
    className,
    icon,
    iconPosition,
    size,
    ...buttonProps
  } = props;
  const classes = classnames(
    `ds-btn-${buttonType}`,
    size,
    className,
  );
  const LeftIcon = () => (
    (icon && iconPosition === 'left') ? <span className="ds-icon-left">{icon}</span> : null
  );
  const RightIcon = () => (
    (icon && iconPosition === 'right') ? <span className="ds-icon-right">{icon}</span> : null
  );
  return (
    <button
      ref={buttonRef}
      className={classes}
      {...buttonProps}
    >
      <LeftIcon />
      {children}
      <RightIcon />
    </button>
  );
};

BaseButton.defaultProps = {
  buttonRef: null,
  className: '',
  icon: null,
  iconPosition: 'left',
};

// Also accepts all <button /> attributes
BaseButton.propTypes = {
  buttonRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  buttonType: PropTypes.oneOf(
    [
      'primary',
      'secondary',
      'tertiary',
      'destructive',
    ],
  ).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  size: PropTypes.oneOf(ButtonSizes).isRequired,
};

export default BaseButton;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Buttons/BaseButton.jsx